export default "/images/vendor/flag-icon-css/flags/1x1/mx.svg?a17b7ad9eaa85411a1e1f8b05ffe4681";